<div id="popup">
    <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <span style="color: white;">
            Add Notes!
        </span>
        <button mat-icon-button mat-dialog-close>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <div class="padding-11">
            <div fxLayout="column" style="overflow: auto;" [formGroup]="firstFormGroup">

              <div class="Description">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Description</mat-label>
                    <textarea trim="blur" matTextareaAutosize matAutosizeMinRows=1
                        matAutosizeMaxRows=5 matInput
                        formControlName="notes" matInput required>
                </textarea>
                    <mat-error
                        *ngIf="firstFormGroup.controls.notes.errors?.required">
                        Please fill out this field.
                    </mat-error>

                </mat-form-field>
              </div>

                <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">

                    <button type="button" mat-raised-button (click)="close()">Cancel
                    </button>

                    <button [disabled]="text !='Save'" (click)="submit()" mat-raised-button>
                        {{text}}
                        <mat-icon *ngIf="text !='Save' ">
                          <mat-spinner color="primary" diameter="20">
                          </mat-spinner>
                        </mat-icon>
                      </button>
                </div>

                <div>
                    <br>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>